
import DROPDOWN_LISTS from '../../components/DropdownLists.json'

class CapViewLateRouteForm {
  constructor(config) {
    /*
      {
        "schoolYear": {
          "required":true,
          "options":[
            {"schoolYear":"23-24"},
            {"schoolYear":"sum-23"},
            {"schoolYear":"22-23"},
            {"schoolYear":"sum-22"}
          ]
        },
        "vendor":{
          "required":true,
          "requires":["vendor_id"],
          "provided":{}
        }
      }
    */
    this.config = config
  }

  checkPermission(options = {}) {
    if (options === undefined) {
      return Boolean(this.config)
    }

    if (options.schoolYear) {
      return this._checkConfigField('schoolYear', options)
    }
    else if (options.district) {
      return this._checkConfigField('district', options)
    }
    else if (options.partition) {
      return this._checkConfigField('partition', options)
    }
    else if (options.vendor) {
      return this._checkConfigField('vendor', options)
    }
    else {
      // options is empty
      return Boolean(this.config)
    }
  }

  getVendorOptions() {
    if (this.config?.vendor?.options) {
      return this.config.vendor.options
    }
    return []
  }

  getSchoolYearOptions() {
    if (this.config?.schoolYear?.options) {
      return this.config.schoolYear.options
    }
    else if (this.config.schoolYear?.all) {
      let schoolYearCodes = []
      for (const code in DROPDOWN_LISTS.schoolYear) {
        schoolYearCodes.push(code)
      }
      return schoolYearCodes
    }
    return []
  }

  checkFieldRequirement(key) {
    if (key === 'schoolYear') {
      return this.config.schoolYear.required
    }
    else if (key === 'vendor_id' || key === 'vendor') {
      return this.config.vendor.required
    }
  }

  checkFieldProvided(key) {
    if (key === 'schoolYear') {
      return this._checkProvidedMap(this.config.schoolYear.provided, 'schoolYear')
    }
    else if (key === 'vendor_id') {
      return this._checkProvidedMap(this.config.vendor.provided, 'vendor_id')
    }
  }

  _checkProvidedMap(map, key) {
    if (map) {
      return map[key]
    }
    else {
      return undefined
    }
  }

  // optionsChangeViewField(fieldKey) {
  //   return this.config[fieldKey].options
  // }

  _checkConfigField(fieldKey, options) {
    if (this.config[fieldKey]) {
      return this.config[fieldKey].includes(options[fieldKey])
    }
    else {
      return false
    }
  }
}

// {
//   'requires': ['vendor_id'],
//   'provided': {},
// }

function key() {
  return 'view_late_route_form'
}

function create(config) {
  return new CapViewLateRouteForm(config)
}

export default {
  key,
  create,
}
